export const customSpaceTokens = {
    1100: '88px',
    1200: '96px',
    1400: '112px',
    1600: '128px'
};

//# sourceMappingURL=space.js.map